import React from 'react';
import {
  SystemOfMeasuresConnectorApollo,
  MeasurementSaveByDateConnectorApollo,
} from '@front-activerse/common-components';
import AddMeasurementContainer from './AddMeasurementContainer';
import { useTimestamp } from '@front-activerse/common-components';

interface IAddMeasurementPageProps {
  availableMeasurements?: string[][];
}

const AddMeasurementPage: React.FC<IAddMeasurementPageProps> = ({ availableMeasurements }) => {
  const { timestamp2 } = useTimestamp();

  return (
    <SystemOfMeasuresConnectorApollo>
      {(systemOfMeasuresData) => (
        <MeasurementSaveByDateConnectorApollo>
          {(saveData) => (
            <AddMeasurementContainer
              key={timestamp2}
              {...saveData}
              {...systemOfMeasuresData}
              availableMeasurements={availableMeasurements}
            />
          )}
        </MeasurementSaveByDateConnectorApollo>
      )}
    </SystemOfMeasuresConnectorApollo>
  );
};

export default AddMeasurementPage;
